import type { CalculatorsOverviewLocaleContent } from '../types'

export const calculatorsOverviewEs: CalculatorsOverviewLocaleContent = {
  title: 'Calculadoras de Ingenieria - Toolvance',
  description: 'Calculadoras gratuitas de ingenieria para calculos electricos, energia, mecanica, termica y fisica.',
  breadcrumbHome: 'Inicio',
  breadcrumbCurrent: 'Calculadoras',
  heading: '🧮 Calculadoras de Ingenieria',
  intro: 'Calculos de ingenieria precisos en 5 disciplinas.',
  countNounSingular: 'calculadora',
  countNounPlural: 'calculadoras',
  popularHeading: 'Calculadoras Populares',
}
